<template>
    <div class="certificate-student c-flex c-row-center c-col-top">
        <div class="cjw-certificate-student c-font-md c-font-line-md c-font-color-main c-relative">
            <!--背景图-->
            <div class="cjw-bgp" :style="filterBodyStyle"></div>

            <div class="cjw-mask" :style="filterMaskStyle">
                <div class="cjw-title c-flex">
                    <div class="c-font-bold">个人证书查询</div>
                </div>
            </div>

            <div class="cjw-form">
                <!-- 个人证书查询 -->
                <div class="c-flex c-row-center">
                    <div class="cjw-card">
                        <Form ref="formData" :model="formData" :rules="ruleData" :label-width="80">
                            <FormItem label="个人姓名" prop="stuName">
                                <Input v-model="formData.stuName" placeholder="请输入姓名"></Input>
                            </FormItem>
                            <FormItem label="手机号码" prop="cellPhone">
                                <Input v-model="formData.cellPhone" placeholder="请输入手机号码"></Input>
                            </FormItem>
<!--                            <FormItem label="证件类型" prop="certType">-->
<!--                                <Select v-model="formData.certType" placeholder="请选择证件类型">-->
<!--                                    <Option value="1">身份证</Option>-->
<!--                                    <Option value="2">护照</Option>-->
<!--                                    <Option value="3">港澳通行证</Option>-->
<!--                                    <Option value="4">台湾通行证</Option>-->
<!--                                    <Option value="5">其他</Option>-->
<!--                                </Select>-->
<!--                            </FormItem>-->
<!--                            <FormItem label="证件号码" prop="certId">-->
<!--                                <Input v-model="formData.certId" placeholder="请输入证件号码"></Input>-->
<!--                            </FormItem>-->
                        </Form>
                        <div class="c-mgt-25">
                            <Button class="cjw-button" type="success" long :loading="loadingRequest"
                                    @click="handleSubmit('formData')">查询
                            </Button>
                        </div>
                    </div>
                </div>

                <!-- 证书查询结果 -->
                <div class="c-mgt-20 cjw-list c-text-center" v-if="showCertList">
                    <div class="c-mgb-20 cjw-title c-flex">
                        <div class="c-font-bold">证书查询结果</div>
                    </div>
                    <!-- 证书列表 -->
                    <div class="cjw-li c-font-md c-font-color-main" v-for="(item, index) in certInfoList"
                         :key="index">
                        <div style="padding: 2px; border: 2px solid #d0d1d2">
                            <div style="padding: 4px; border: 1px solid #d0d1d2">
                                <div class="c-mgb-15 c-flex c-font-xs">证书编号：{{ item.certCode }}</div>
                                <div class="c-mgb-4 c-font-bold" style="font-size: 28px;">中国少年英语报</div>
                                <div class="c-mgb-20 c-font-bold">词汇能力展示活动</div>
                                <div class="c-mgb-4 c-font-bold" style="font-size: 28px;" :class="{
                            'cjw-color-red': item.awardName === 'CKE小达人',
                            'cjw-color-yellow': item.awardName === '金星小达人',
                            'cjw-color-gray': item.awardName === '银星小达人',
                            'cjw-color-brown': item.awardName === '铜星小达人',
                        }">{{ item.awardName }}</div>
                                <div class="c-mgb-25 c-font-bold" :class="{
                            'cjw-color-red': item.awardName === 'CKE小达人',
                            'cjw-color-yellow': item.awardName === '金星小达人',
                            'cjw-color-gray': item.awardName === '银星小达人',
                            'cjw-color-brown': item.awardName === '铜星小达人',
                        }">({{ item.stageName }})</div>
                                <div class="c-mgb-10 c-flex">
                                    <div class="c-flex-1 c-text-right">姓名：</div>
                                    <div class="c-flex-1 c-text-left c-font-bold">{{ formData.stuName }}</div>
                                </div>
                                <div class="c-mgb-25 c-flex">
                                    <div class="c-flex-1 c-text-right">组别：</div>
                                    <div class="c-flex-1 c-text-left c-font-bold">{{ item.groupName }}</div>
                                </div>
                                <div class="c-flex c-row-right c-font-xs">颁发时间：{{ item.packTime }}</div>
                            </div>
                        </div>
                    </div>
                    <!-- 证书查询为空 -->
                    <div class="cjw-li c-font-sm c-font-color-routine" v-if="!certInfoList.length">
                        <div class="c-mgt-10">{{ requestErrorMsg }}</div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import config from "@/common/js/config";
import axios from 'axios';
import useValidatePhone from "@/hooks/useValidatePhone";

export default {
    name: 'certificate-student',
    data() {
        return {
            bgpImageUrl: config.resourceBaseUrl + '/cke/cert/student/bgp_001.jpg',
            studentCertQueryUrl: config.requestBaseUrl + '/api/cert/queryStuCert',
            studentCertQueryUrlV2: config.requestBaseUrl + '/api/cert/v2/queryStuCert ',

            formData: {
                stuName: '',
                cellPhone: '',
                certType: '',
                certId: '',
            },
            ruleData: {
                stuName: [
                    {required: true, message: '请输入姓名', trigger: 'blur'}
                ],
                cellPhone: [
                    {required: true, message: '请输入手机号码', trigger: 'blur'},
                    {validator: useValidatePhone, trigger: 'blur'}
                ],
                // certType: [
                //     {required: true, message: '请选择证件类型', trigger: 'change'}
                // ],
                // certId: [
                //     {required: true, message: '请输入证件号码', trigger: 'blur'}
                // ],
            },


            loadingRequest: false,
            certInfoList: [],
            requestErrorMsg: '',
            showCertList: false,
        }
    },
    computed: {
        filterBodyStyle() {
            let filterBodyStyle = {};
            filterBodyStyle.backgroundImage = `url(${this.bgpImageUrl})`;
            filterBodyStyle.backgroundSize = `cover`;

            return filterBodyStyle;
        },
        filterMaskStyle() {
            let filterBodyStyle = {};
            filterBodyStyle.backgroundColor = 'rgba(255, 255, 255, 0.8)';

            return filterBodyStyle;
        },
    },
    mounted() {},
    methods: {
        // 证书查询
        handleSubmit(name) {
            this.$refs[name].validate((valid) => {
                if (valid) {
                    this.loadingRequest = true;
                    this.requestErrorMsg = '';
                    this.certInfoList = [];
                    // 发送 POST 请求
                    axios.post(this.studentCertQueryUrlV2, {
                        stuName: this.formData.stuName,
                        cellPhone: this.formData.cellPhone, // v2
                        // certType: this.formData.certType, // v1
                        // certId: this.formData.certId, // v1
                    }).then((resp) => {
                        this.loadingRequest = false;
                        // 请求成功
                        if (resp.status === 200) {
                            // 业务逻辑成功
                            if (resp.data.code === 200) {
                                this.certInfoList = resp.data.data;
                                if(!this.certInfoList.length) {
                                    this.requestErrorMsg = '您还没有证书哦~';
                                }
                                this.showCertList = true;
                            } else {
                                // 业务逻辑失败
                                this.requestErrorMsg = resp.data.msg;
                                // this.requestErrorMsg = '您还没有证书哦~';
                                this.showCertList = true;
                                // this.$Message.warning(this.requestErrorMsg);
                            }
                        } else {
                            // 请求失败
                            this.requestErrorMsg = `查询失败：${resp.statusText}`;
                        }

                    }).catch((error) => {
                        // console.log(error);
                        this.loadingRequest = false;
                        this.requestErrorMsg = `查询失败：${error.message}`;
                    });
                }
            })
        },
    }
}
</script>

<style scoped lang="less">
.certificate-student {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    background-color: #f8f8f8;

    .cjw-certificate-student {
        width: 100%;
        height: 100%;
    }
}


.cjw-bgp,
.cjw-mask {
    position: absolute;
    width: 100%;
    height: 180px;

    .cjw-title {
        padding: 20px 16px;
        letter-spacing: 1px;
        line-height: 32px;
    }
}

.cjw-form {
    position: absolute;
    top: 72px;
    left: 0;
    right: 0;
    padding: 0 16px 50px;

    .cjw-card {
        display: inline-block;
        padding: 20px;
        width: 100%;
        max-width: 400px;
        border: 1px solid #e8e8e8;
        border-radius: 16px;
        box-shadow: 0 0 10px #e8e8e8;
        background-color: #ffffff;
    }

    .cjw-button {
        border-radius: 32px;
    }
}

.cjw-list {
    .cjw-title {
        letter-spacing: 1px;
        line-height: 32px;
    }

    .cjw-li {
        margin-bottom: 10px;
        display: inline-block;
        padding: 15px;
        width: 100%;
        max-width: 400px;
        min-height: 250px;
        border: 1px solid #e8e8e8;
        border-radius: 16px;
        box-shadow: 0 0 10px #e8e8e8;
        background-color: #ffffff;

        .cjw-label {
            min-width: 80px;
            text-align: left;
        }

        .cjw-content {
            flex: 1;
            text-align: right;
        }
    }
}

.cjw-color-red {
    color: #da4441;
}
.cjw-color-yellow {
    color: #e4c279;
}
.cjw-color-gray {
    color: #d0d1d2;
}
.cjw-color-brown {
    color: #e1b4a0;
}
</style>
